import script from "./ScMark.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScMark.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__